import * as React from 'react'
import * as t from './types'
import styled from 'styled-components'
import theme from 'theme'
import WistiaPlayer from 'theme/atoms/WistiaPlayer'
import Markdown from 'theme/atoms/Markdown'
import ProductImage from './ProductImage'
import Link from 'theme/atoms/Link'
import { ReactComponent as LinkArrow } from 'assets/link-arrow.svg'

export function TeaserGrid(props: t.Props) {
  const firstProductImage = {
    img: props.context.optImages[0],
    alt: props.image0Alt
  }
  const secondProductImage = {
    img: props.context.optImages[1],
    alt: props.image1Alt
  }
  const thirdProductImage = {
    img: props.context.optImages[2],
    alt: props.image2Alt
  }
  const fourthProductImage = {
    img: props.context.optImages[3],
    alt: props.image3Alt
  }
  const fifthProductImage = {
    img: props.context.optImages[4],
    alt: props.image4Alt
  }

  return (
    <Wrapper className="TeaserGrid" data-cy-ctx="organisms/TeaserGrid">
      <div className="main-grid">
        <div className="section">
          {props.wistiaVideoId && (
            <div data-cy-state="show-video">
              <WistiaPlayer link={props.wistiaVideoId} />
            </div>
          )}

          {!props.wistiaVideoId && (
            <div data-cy-state="show-image">
              <Link to={props.link}>
                <ProductImage
                  img={firstProductImage.img}
                  alt={firstProductImage.alt}
                />
              </Link>
            </div>
          )}
        </div>
        <div className="section">
          <div className="secondary-grid">
            <Link to={props.link}>
              <ProductImage
                img={secondProductImage.img}
                alt={secondProductImage.alt}
              />
            </Link>
            <Link to={props.link}>
              <ProductImage
                img={thirdProductImage.img}
                alt={thirdProductImage.alt}
              />
            </Link>
            <Link to={props.link} className="hide-on-mobile">
              <ProductImage
                img={fourthProductImage.img}
                alt={fourthProductImage.alt}
              />
            </Link>
            <Link to={props.link} className="hide-on-mobile">
              <ProductImage
                img={fifthProductImage.img}
                alt={fifthProductImage.alt}
              />
            </Link>
          </div>
        </div>
        <div className="section description-section">
          <div className="description">
            <Markdown html={props.context.descriptionTextHtml}></Markdown>
          </div>
          {props.link.trim() !== '' && props.linkLabel.trim() !== '' && (
            <div className="link" data-cy-state="show-link">
              <Link to={props.link}>{props.linkLabel}</Link>{' '}
              <LinkArrow className="link-arrow" />
            </div>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

export default TeaserGrid

const tabletBreakpoint = theme.ms.MD
const desktopBreakpoint = theme.ms.LG

const Wrapper = styled.div`
  width: 100%;
  display: block;
  flex-direction: column;

  > .header {
    ${theme.ty('rc-2xl')};
    background-color: ${theme.colors.shade.b6};

    padding: ${theme.spacing('xs')};
    @media (min-width: ${tabletBreakpoint}px) {
      padding: ${theme.spacing('m')};
    }

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  > .main-grid {
    max-width: 100%;
    display: grid;
    grid-template-columns:
      calc(66.66% - ${theme.spacing('xs')})
      calc(33.33% - ${theme.spacing('xs')});

    @media (min-width: ${tabletBreakpoint}px) {
      grid-template-columns:
        calc(50% - ${theme.spacing('m')})
        calc(50% - ${theme.spacing('m')});
    }

    @media (min-width: ${desktopBreakpoint}px) {
      grid-template-columns:
        calc(33.33% - ${theme.spacing('m')})
        calc(33.33% - ${theme.spacing('m')})
        calc(33.33% - ${theme.spacing('m')});
    }

    margin-top: ${theme.spacing('xs')};
    grid-gap: ${theme.spacing('xs')};
    @media (min-width: ${tabletBreakpoint}px) {
      margin-top: ${theme.spacing('m')};
      grid-gap: ${theme.spacing('m')};
    }

    align-items: start;

    > .section {
      aspect-ratio: 1 / 1;

      > .secondary-grid {
        display: grid;
        grid-gap: ${theme.spacing('xs')};
        grid-template-columns: 1fr;

        @media (min-width: ${tabletBreakpoint}px) {
          grid-template-columns: repeat(2, 1fr);
          grid-gap: ${theme.spacing('m')};
        }

        > .hide-on-mobile {
          display: none;
          @media (min-width: ${tabletBreakpoint}px) {
            display: block;
          }
        }
      }

      > .link {
        display: flex;
        align-items: center;
        font-weight: bold;
        margin-top: ${theme.spacing('m')};

        > a {
          color: ${theme.colors.brand.lusini};
        }

        > .link-arrow {
          margin-left: ${theme.spacing('xs')};
          color: ${theme.colors.brand.lusini};

          path: {
            fill: ${theme.colors.brand.lusini};
          }
        }
      }
    }

    > .description-section {
      aspect-ratio: revert;
      grid-column: 1 / -1;
      @media (min-width: ${desktopBreakpoint}px) {
        grid-column: unset;
      }
    }
  }
`
